import {computed} from 'vue'
import {useRoute, useRouter} from 'vue-router'

export function useIsRouteActive(targetName, targetParams) {
  const route = useRoute()
  const router = useRouter()

  const paramsMatch = params => {
    if (!targetParams) {
      return true
    }

    return Object.entries(targetParams).every(([key, value]) => params?.[key] === value)
  }

  return computed(() => {
    if (route.name === targetName && paramsMatch(route.params)) {
      return true
    }

    let currentMeta = route.meta
    while (currentMeta?.parent) {
      if (currentMeta.parent === targetName) {
        return true
      }

      const parentRoute = router?.getRoutes().find(record => record.name === currentMeta.parent)
      currentMeta = parentRoute?.meta
    }

    return false
  })
}
